(function documentViewerrModuleDefinition() {
    'use strict';

    angular.module('DocumentViewer', [])
        .directive('documentViewer', ['$translate',
            function ($translate) {
                return {
                    scope: {
                        src: '=',
                        auditEntity: '='
                    },

                    controller: [
                        '$scope', '$element', 'auditService', 'fileService', '$sce', 'auth', function ($scope, $element, auditService, fileService, $sce, auth) {

                            function detectIE() {
                                var ua = window.navigator.userAgent;

                                var msie = ua.indexOf('MSIE ');
                                if (msie > 0) {
                                    // IE 10 or older => return version number
                                    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                                }

                                var trident = ua.indexOf('Trident/');
                                if (trident > 0) {
                                    // IE 11 => return version number
                                    var rv = ua.indexOf('rv:');
                                    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                                }

                                return false;
                            };

                            $scope.canDownloadPdf = auth.isInRole('FILE DOWNLOAD');
                            $(document).bind('keydown', function (e) {
                                if (e.ctrlKey && (e.which == 83)) {
                                    e.preventDefault();
                                    return $scope.canDownloadPdf;
                                }
                            });

                            $scope.IsIe = detectIE();

                            $scope.convertDataURIToBase64 = function (dataURI) {
                                var BASE64_MARKER = ';base64,';
                                var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
                                return dataURI.substring(base64Index);
                            }                            

                            $scope.getURLForViewer = function (value) {
                                fileService.shareInline($scope.convertDataURIToBase64(value)).then(function (result) {
                                    $scope.src = $sce.trustAsResourceUrl(result);
                                }, function (error) {
                                    defered.reject('Api failed');
                                });
                            }

                            PDFViewerApplicationIe.auditEntity = $scope.auditEntity;
                            PDFViewerApplication.auditEntity = $scope.auditEntity;

                            PDFViewerApplicationIe.download = function () {
                                pdfDownload(PDFViewerApplicationIe, true);
                            };
                            PDFViewerApplication.download = function () {
                                pdfDownload(PDFViewerApplication, $scope.IsIe);
                            };

                            function pdfDownload(viewerApp, isIe) {
                                // Audit download
                                if (viewerApp.auditEntity) {
                                    auditService.create(viewerApp.auditEntity);
                                }

                                function downloadByUrl() {
                                    downloadManager.downloadUrl(url, filename);
                                }
                                var url = viewerApp.baseUrl;
                                var filename = getPDFFileNameFromURL(viewerApp.url);
                                var downloadManager = PDFViewerApplication.downloadManager;
                                viewerApp.pdfDocument.getData().then(function getDataSuccess(data) {
                                    var blob = new Blob([data], { type: 'application/pdf' })
                                    if (isIe) {
                                        if (navigator.msSaveBlob) {
                                            // IE10 / IE11
                                            if (!navigator.msSaveBlob(blob, filename)) {
                                                this.downloadUrl(url, filename);
                                            }
                                            return;
                                        }
                                    }
                                    else {
                                        downloadManager.download(blob, url, filename);
                                    }
                                }, downloadByUrl).then(null, downloadByUrl);
                            };
                        }],
                    restrict: 'E',
                    templateUrl: '/app/components/document-viewer/document-viewer.html',
                    link: function ($scope) {
                        $scope.$watch('src', function (value) {
                            // all the code here...
                            if (value && value.indexOf('data') >= 0) {
                                if ($scope.IsIe) {
                                    $scope.getURLForViewer(value);
                                }
                                else {
                                    $scope.src = value;
                                }
                            }
                        });
                    }
                };
            }
        ]);
})();